var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import RichText from '@/views/announcement/RichText/RichText1.vue';
import { getCommbookContent, validCommbookContent } from '@/common/video/commbookContent';
import AttachmentStrip from './attachment-strip.vue';
import { editConversation, editReply, getCreateTopics } from '../api';
import { attachments, messageHtml, safeUrl } from '../utils';
var emojiSpan = /<span\b(?=[^>]*\bdata-type=["']emoji["'])[^>]*>([^<]*)<\/span>/gi;
var emojiBetweenMatchingMarks = /<\/(strong|em|u|s)>(<span\b(?=[^>]*\bdata-type=["']emoji["'])[^>]*>[^<]*<\/span>)<\1>/gi;
function comparableHtml(html) {
    return html.replace(emojiBetweenMatchingMarks, '$2').replace(emojiSpan, '$1');
}
export default Vue.extend({
    name: 'GlobalCommbookEditMessage',
    components: { RichText: RichText, AttachmentStrip: AttachmentStrip },
    props: {
        record: { type: Object, required: true },
        conversationId: { type: String, required: true },
        reply: Boolean
    },
    data: function () {
        var html = messageHtml(this.reply ? this.record.response : this.record.message || this.record.plainTextMessage);
        var files = attachments(this.record);
        return {
            title: String(this.record.title || ''),
            topic: String(this.record.topic || ''),
            topics: [],
            topicOpen: false,
            topicsLoading: false,
            topicsError: '',
            html: html,
            files: files,
            originalHtml: html,
            originalFiles: JSON.stringify(files),
            originalTitle: String(this.record.title || '').trim(),
            originalTopic: String(this.record.topic || '').trim(),
            uploads: [],
            saving: false,
            videoUploading: false,
            alive: true,
            error: ''
        };
    },
    computed: {
        contentError: function () {
            var content = getCommbookContent(this.html);
            if (content.hasInvalidMedia)
                return 'Please remove or upload the unavailable image or video again.';
            return content.characterCount > 4000 ? 'Character limit of 4000' : '';
        },
        titleCount: function () {
            return Array.from(this.title.trim()).length;
        },
        messageCount: function () {
            return getCommbookContent(this.html).characterCount;
        },
        hasChanges: function () {
            return (comparableHtml(this.html) !== comparableHtml(this.originalHtml) ||
                JSON.stringify(this.files) !== this.originalFiles ||
                (!this.reply &&
                    (this.title.trim() !== this.originalTitle || this.topic.trim() !== this.originalTopic)));
        },
        canSave: function () {
            return (this.alive &&
                !this.saving &&
                !this.videoUploading &&
                this.hasChanges &&
                !this.uploads.length &&
                validCommbookContent(this.html, this.reply ? this.files : []) &&
                (this.reply ||
                    (!!this.title.trim() &&
                        this.titleCount <= 200 &&
                        !!this.topic.trim() &&
                        this.topic.trim().length <= 45)));
        }
    },
    created: function () {
        if (!this.reply)
            this.loadTopics();
    },
    mounted: function () {
        // TipTap applies its default paragraph formatting during child mount, before user input.
        var editor = this.$refs.editor;
        if (editor && editor.editor) {
            this.html = editor.editor.getHTML();
            this.originalHtml = this.html;
        }
        if (!this.reply)
            document.addEventListener('mousedown', this.onOutsideClick);
    },
    beforeDestroy: function () {
        this.alive = false;
        this.saving = false;
        this.videoUploading = false;
        if (!this.reply)
            document.removeEventListener('mousedown', this.onOutsideClick);
    },
    methods: {
        onVideoUploading: function (busy) {
            if (!this.alive || this.saving)
                return;
            this.videoUploading = busy;
        },
        onOutsideClick: function (event) {
            var topic = this.$refs.topicField;
            if (topic && !topic.contains(event.target))
                this.topicOpen = false;
        },
        loadTopics: function () {
            return __awaiter(this, void 0, void 0, function () {
                var topics, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.topicsLoading = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getCreateTopics()];
                        case 2:
                            topics = _a.sent();
                            if (this.alive)
                                this.topics = topics;
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            if (this.alive)
                                this.topicsError = error_1 instanceof Error ? error_1.message : 'Unable to load topics.';
                            return [3 /*break*/, 5];
                        case 4:
                            if (this.alive)
                                this.topicsLoading = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        selectTopic: function (option) {
            if (!this.alive || this.saving)
                return;
            this.topic = option;
            this.topicOpen = false;
            this.error = '';
        },
        onHtml: function (html) {
            if (!this.alive || this.saving)
                return;
            this.html = html || '';
            this.error = '';
        },
        onFile: function (value) {
            var _this = this;
            if (!this.alive || this.saving)
                return;
            var input = Array.isArray(value) ? value : [value];
            var normalized = input.reduce(function (result, file) {
                if (!file || typeof file !== 'object')
                    return result;
                var src = safeUrl(file.src);
                if (src) {
                    result.push({
                        src: src,
                        fileName: String(file.fileName || file.name || 'Attachment'),
                        size: Number(file.size) || undefined
                    });
                }
                return result;
            }, []);
            var completedIds = input
                .filter(function (file) { return file && file.uid != null && safeUrl(file.src); })
                .map(function (file) { return String(file.uid); });
            this.uploads = this.uploads.filter(function (upload) { return !completedIds.includes(upload.id); });
            normalized.forEach(function (file) {
                if (!_this.files.some(function (existing) { return existing.src === file.src; }))
                    _this.files.push(file);
            });
            this.error = '';
        },
        onUploadStart: function (upload) {
            if (!this.alive || this.saving)
                return;
            this.uploads.push(__assign(__assign({}, upload), { percent: null, status: 'uploading', error: '' }));
            this.error = '';
        },
        onUploadProgress: function (event) {
            if (!this.alive || this.saving)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload || upload.status === 'error')
                return;
            upload.percent = event.percent;
            upload.status = event.percent === 100 ? 'processing' : 'uploading';
        },
        onUploadError: function (event) {
            if (!this.alive || this.saving)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload)
                return;
            upload.status = 'error';
            upload.error = event.message;
        },
        removeUpload: function (id) {
            if (!this.alive || this.saving)
                return;
            this.uploads = this.uploads.filter(function (upload) { return upload.id !== id; });
        },
        removeFile: function (index) {
            if (this.alive && !this.saving)
                this.files.splice(index, 1);
        },
        setEditorEnabled: function (enabled) {
            var editor = this.$refs.editor;
            if (editor && editor.editor)
                editor.editor.setEditable(enabled);
        },
        save: function () {
            return __awaiter(this, void 0, void 0, function () {
                var conversationId, recordId, isCurrent, html, files, error_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canSave)
                                return [2 /*return*/];
                            this.saving = true;
                            this.error = '';
                            this.setEditorEnabled(false);
                            this.topicOpen = false;
                            conversationId = this.conversationId;
                            recordId = String(this.record.id);
                            isCurrent = function () {
                                return _this.alive && _this.conversationId === conversationId && String(_this.record.id) === recordId;
                            };
                            html = getCommbookContent(this.html).html;
                            files = this.files.slice();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            if (!this.reply) return [3 /*break*/, 3];
                            return [4 /*yield*/, editReply(conversationId, recordId, html, files)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, editConversation(conversationId, {
                                title: this.title.trim(),
                                topic: this.topic.trim(),
                                message: html,
                                attachments: files
                            })];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            if (!isCurrent())
                                return [2 /*return*/];
                            this.originalHtml = this.html;
                            this.originalFiles = JSON.stringify(this.files);
                            this.originalTitle = this.title.trim();
                            this.originalTopic = this.topic.trim();
                            this.$emit('saved');
                            return [3 /*break*/, 8];
                        case 6:
                            error_2 = _a.sent();
                            if (isCurrent())
                                this.error = error_2 instanceof Error ? error_2.message : 'Unable to save. Please try again.';
                            return [3 /*break*/, 8];
                        case 7:
                            if (isCurrent()) {
                                this.saving = false;
                                this.setEditorEnabled(true);
                            }
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }
    }
});
